import { render, staticRenderFns } from "./CamDisplay.vue?vue&type=template&id=328c1ff6&scoped=true&"
import script from "./CamDisplay.vue?vue&type=script&lang=js&"
export * from "./CamDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c1ff6",
  null
  
)

export default component.exports